import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { ExternalPointFormModel } from 'src/app/shared/model/external-point.model';

export function buildExternalPointForm(fb: FormBuilder): FormGroup<{
  displayLabels: FormControl<ExternalPointFormModel['displayLabels']>;
  dataproviderId: FormControl<ExternalPointFormModel['dataproviderId']>;
  channelId: FormControl<ExternalPointFormModel['channelId']>;
  reportingInterval: FormControl<ExternalPointFormModel['reportingInterval']>;
  sourceId: FormControl<ExternalPointFormModel['sourceId']>;
  expressionFactor: FormControl<ExternalPointFormModel['expressionFactor']>;
  veeBypass: FormControl<ExternalPointFormModel['veeBypass']>;
}> {
  const veeBypassCtrl = fb.control<ExternalPointFormModel['veeBypass']>(true, {
    nonNullable: true,
  });

  const form = fb.group({
    displayLabels: fb.control<ExternalPointFormModel['displayLabels']>(
      { en_US: '' },
      {
        validators: [Validators.required],
        nonNullable: true,
      },
    ),
    dataproviderId: fb.control<ExternalPointFormModel['dataproviderId']>('', {
      validators: [Validators.required],
      nonNullable: true,
    }),
    channelId: fb.control<ExternalPointFormModel['channelId']>('', {
      validators: [Validators.required],
      nonNullable: true,
    }),
    reportingInterval: fb.control<ExternalPointFormModel['reportingInterval']>('', {
      validators: [Validators.required],
      nonNullable: true,
    }),
    sourceId: fb.control<ExternalPointFormModel['sourceId']>('', {
      validators: [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(80),
        Validators.pattern(/^[a-zA-Z0-9\-_ ]+$/),
      ],
      nonNullable: true,
    }),
    expressionFactor: fb.control<ExternalPointFormModel['expressionFactor']>(1, {
      validators: [Validators.required, Validators.min(1)],
      nonNullable: true,
    }),
    veeBypass: veeBypassCtrl,
  });

  veeBypassCtrl.disable({ emitEvent: false });

  return form;
}
